export { PrimaryPanelsSlot } from './basic-slots/PrimaryPanelsSlot';
export { PrimaryButtonsSlot } from './basic-slots/PrimaryButtonsSlot';
export { TopBarSecondaryActionsSlot } from './basic-slots/TopBarSecondaryActionsSlot';
export { HelpMenuItemsSlot } from './basic-slots/HelpMenuItemsSlot';
export { StickyPanelSlot } from './basic-slots/StickyPanelSlot';
export { StageLayerSlot } from './basic-slots/StageLayerSlot';
export { ToolsMenuItemSlot } from './basic-slots/ToolsMenuItemSlot';
